/**
 * Article reading progress (sections/article.liquid): a 2px rule, fixed
 * directly under the visible header, that fills as the article body is read.
 * The offset follows the header's rendered bottom edge so announcement bars
 * and sticky-header transitions do not push the rule into the page content.
 */
function initReadingProgress() {
  const bar = document.querySelector('[data-reading-progress]');
  const fill = document.querySelector('[data-reading-progress-fill]');
  const source = document.querySelector('[data-reading-progress-source]');
  if (!bar || !fill || !source) return;

  function setOffset() {
    const header = document.querySelector('.site-header');
    const isSticky = header?.classList.contains('site-header--sticky');
    const top = isSticky ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    bar.style.top = `${top}px`;
  }

  function update() {
    setOffset();
    const rect = source.getBoundingClientRect();
    const total = rect.height + window.innerHeight;
    const scrolled = window.innerHeight - rect.top;
    const percent = total > 0 ? Math.min(100, Math.max(0, (scrolled / total) * 100)) : 0;
    fill.style.width = `${percent}%`;
  }

  setOffset();
  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', () => {
    setOffset();
    update();
  });
  window.addEventListener('load', update);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initReadingProgress);
} else {
  initReadingProgress();
}
